var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPuckDropped(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 125,
    height: 125,
    viewBox: "0 0 125 125",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M82.979 8.40796L70.5168 44.5828L63.8501 27.6887L72.9285 4.6582C73.7493 2.5874 75.7063 1.26172 77.916 1.26172C81.6912 1.26147 84.2036 5.04932 82.979 8.40796Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M78.8123 116.87C78.8123 120.657 75.7314 123.738 71.9309 123.738H53.0544C49.2666 123.738 46.1855 120.657 46.1855 116.87C46.1855 113.069 49.2664 109.988 53.0544 109.988H71.9309C75.7314 109.988 78.8123 113.069 78.8123 116.87Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.4983 83.2441C19.4963 83.2493 19.4961 83.2546 19.4944 83.2598L12.1182 103.712H26.9568C26.9585 103.707 26.9587 103.702 26.9605 103.698L34.3296 83.2444H19.4983V83.2441Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M54.3169 51.8555L43.1047 80.3027C42.4104 82.0579 40.668 83.2446 38.7612 83.2446H38.354C38.3523 83.2498 38.352 83.2546 38.3503 83.2598L30.9814 103.712H38.1677C45.3396 103.712 51.7158 99.1541 54.0391 92.3735L61.1604 71.7292L54.3169 51.8555Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4731 83.2441H13.0915C10.8818 83.2441 8.92479 84.5825 8.10423 86.6533L4.291 96.363C3.03539 99.5303 5.0161 102.911 8.13768 103.583L15.4731 83.2441Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M96.6755 103.698C96.6772 103.702 96.6775 103.707 96.6792 103.712H114.043L106.667 83.2598C106.665 83.2546 106.665 83.2493 106.663 83.2441H89.3066L96.6755 103.698Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M120.707 96.3774L116.894 86.6426C116.073 84.5845 114.116 83.2461 111.894 83.2461H110.688L117.901 103.244C120.408 102.124 121.819 99.1577 120.707 96.3774Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M85.2859 83.26C85.2705 83.2175 85.2659 83.1743 85.2537 83.1313C83.7478 82.812 82.4775 81.7749 81.8931 80.303L52.0569 4.6582C51.2488 2.6001 49.2918 1.26172 47.082 1.26172C44.1147 1.26172 41.7031 3.67334 41.7031 6.62793C41.7031 7.22144 41.8042 7.8147 41.9934 8.37036L70.9458 92.3738C73.269 99.1541 79.6455 103.712 86.8171 103.712H92.6545L85.2859 83.26Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPuckDropped);
export default __webpack_public_path__ + "static/media/puck-dropped.0e7fc30660dd789f78cb605aba122fe7.svg";
export { ForwardRef as ReactComponent };